import { createAction, props } from '@ngrx/store';

import { NewsfeedContentSource, NewsfeedResult } from './newsfeed-results.models';

//Basic actions

export const setSource = createAction('[Newsfeed/API] Set Newsfeed source', props<{ source: NewsfeedContentSource }>());
export const loadContent = createAction(
  '[Newsfeed/API] Load Newsfeed Results',
  props<{ source: NewsfeedContentSource }>()
);
export const keepContent = createAction('[Newsfeed/API] Keep loaded Newsfeed results');
export const loadMoreContent = createAction(
  '[Newsfeed/API] Load more results',
  props<{ source: NewsfeedContentSource }>()
);
export const loadContentSuccess = createAction(
  '[Newsfeed/API] Load Newsfeed Results success',
  props<{ results: NewsfeedResult[]; count: number }>()
);
export const loadMoreContentSuccess = createAction(
  '[Newsfeed/API] Load more Results success',
  props<{ results: NewsfeedResult[]; count: number }>()
);

// Load content

export const loadRootChannel = createAction('[Newsfeed/API] Load root Newsfeed channel');
export const loadRootChannelSuccess = createAction(
  '[Newsfeed/API] Load root Newsfeed channel success',
  props<{
    results: NewsfeedResult[];
    count: number;
    seed: number;
  }>()
);
export const loadRootChannelFailure = createAction(
  '[Newsfeed/API] Load root Newsfeed channel failure',
  props<{ error: string }>()
);

export const loadSubscribedChannel = createAction(
  '[Newsfeed/API] Load subscribed Newsfeed channel',
  props<{ fairId: string; exhibitorId: string }>()
);
export const loadSubscribedChannelSuccess = createAction(
  '[Newsfeed/API] Load subscribed Newsfeed channel success',
  props<{
    fairId: string;
    exhibitorId: string;
    results: NewsfeedResult[];
    nextCursor: string | undefined;
  }>()
);
export const loadSubscribedChannelFailure = createAction(
  '[Newsfeed/API] Load subscribed Newsfeed channel failure',
  props<{ error: string }>()
);

export const loadUserHistoryChannel = createAction('[Newsfeed/API] Load User History channel');
export const loadUserHistoryChannelSuccess = createAction(
  '[Newsfeed/API] Load User History channel success',
  props<{ results: NewsfeedResult[]; count: number; from: number }>()
);
export const loadUserHistoryChannelFailure = createAction(
  '[Newsfeed/API] Load User History channel failure',
  props<{ error: string }>()
);

// Load more content

export const loadMoreFromRootChannel = createAction(
  '[Newsfeed/API] Load more content from root channel',
  props<{ from: number; seed: number | undefined }>()
);
export const loadMoreFromRootChannelSuccess = createAction(
  '[Newsfeed/API] Load more content from root channel success',
  props<{ results: NewsfeedResult[] }>()
);
export const loadMoreFromRootChannelFailure = createAction(
  '[Newsfeed/API] Load more content from root channel failure',
  props<{ error: string }>()
);

export const loadMoreFromSubscribedChannel = createAction(
  '[Newsfeed/API] Load more content from scubribed channel',
  props<{ fairId: string; exhibitorId: string; cursor: string | undefined }>()
);
export const loadMoreFromSubscribedChannelSuccess = createAction(
  '[Newsfeed/API] Load more content from scubribed channel success',
  props<{ fairId: string; exhibitorId: string; results: NewsfeedResult[]; nextCursor: string | undefined }>()
);
export const loadMoreFromSubscribedChannelFailure = createAction(
  '[Newsfeed/API] Load more content from scubribed channel failure',
  props<{ error: string }>()
);

export const loadMoreFromUserHistoryChannel = createAction(
  '[Newsfeed/API] Load more content from User History channel',
  props<{ from: number }>()
);
export const loadMoreFromUserHistoryChannelSuccess = createAction(
  '[Newsfeed/API] Load more content from User History channel success',
  props<{ results: NewsfeedResult[]; from: number }>()
);
export const loadMoreFromUserHistoryChannelFailure = createAction(
  '[Newsfeed/API] Load more content from User History channel failure',
  props<{ error: string }>()
);
